import { Expose, Type } from "class-transformer";
import CompanyGroupRes from "../companyGroup/CompanyGroupRes";
import { CastExaminationType } from "types/enum/CastExaminationType";

export default class CompanyRes {
  @Expose() readonly companyId!: number;
  @Expose() readonly companyGroupId!: number;
  @Expose() readonly name!: string;
  @Expose() readonly tel!: string;
  @Expose() readonly email!: string;
  @Expose() readonly kana!: string;
  @Expose() readonly representativeName!: string;
  @Type(() => Boolean)
  @Expose()
  readonly isCallCenterContract!: boolean;
  @Expose() readonly changeReserve!: number;
  @Type(() => CompanyGroupRes)
  @Expose()
  readonly companyGroup!: CompanyGroupRes;
  @Type(() => Boolean)
  @Expose()
  readonly pointShopFlag!: boolean;

  @Type(() => Boolean)
  @Expose()
  readonly guestCategoryShopFlag!: boolean;
  @Expose() readonly sort!: number | null;
  @Expose() readonly castExaminationType!: CastExaminationType | null;
  @Expose() readonly castExaminationCount!: number | null;
  @Expose() readonly changeDateTime!: string;
  // #473: URL 短縮 SMS 利用可否 (会社単位)
  @Type(() => Boolean)
  @Expose()
  readonly urlPageSmsEnabled!: boolean;
}
